import { render, staticRenderFns } from "./driversFee.vue?vue&type=template&id=3ee3aba1&scoped=true&"
import script from "./driversFee.vue?vue&type=script&lang=js&"
export * from "./driversFee.vue?vue&type=script&lang=js&"
import style0 from "./driversFee.vue?vue&type=style&index=0&id=3ee3aba1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee3aba1",
  null
  
)

export default component.exports